module.exports = __webpack_public_path__ + "img/1-02.a3f24d75.png";